<template>
  <div class="self-restaurant-content self_c">
    <headNav color="#56AC9A" />
    <div class="self-restaurant-body self_b">
      <van-pull-refresh
        pulling-text="下拉既可刷新"
        loosing-text="釋放立即刷新"
        loading-text="加載中..."
        class="self-restaurant-refresh"
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <van-list
          v-model="upLoading"
          :finished="finished"
          finished-text="沒有更多了"
          loading-text="加載中..."
          @load="onUpLoad"
        >
          <div
            class="self-restaurant-list-item"
            v-for="(item, index) in datas"
            :key="index"
            @click="toDetails(index, item.id)"
          >
            <van-image
              class="self-restaurant-list-img"
              :style="`height:${imgH}px;`"
              fit="cover"
              radius="8px 8px 0 0 "
              :src="item.restaurantInfoImg"
            >
              <template v-slot:loading>
                <van-loading
                  type="spinner"
                  size="20"
                />
              </template>
              <template v-slot:error>
                <img
                  src="../../assets/icon/default.png"
                  style="width:100%;height:100%;border-radius: 10px;"
                />
              </template>
            </van-image>
            <div class="self-restaurant-item-line">
              <div class="default-box">
                <div class="self-restaurant-item-name">
                  {{ item.restaurantName }}
                </div>
                <div
                  v-if="item.addressDetail"
                  class="self-restaurant-item-address"
                >
                  <img src="../../assets/dizhi.png" />
                  <span>{{ item.addressDetail }}</span>
                </div>
              </div>
              <div
                class="coll"
                v-if="showCollect"
              >
                <van-icon
                  @click.stop="onColler(item)"
                  :class="item.collSort > 0 ? 'self-active' : '' "
                  :name="item.collSort > 0 ? 'star' : 'star-o'"
                />
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import headNav from "@/components/headNav";
import { PullRefresh, List } from "vant";
import { getRestaurantNew, getRestaurantNew_v2 } from "@/js/api";
import util from "@/js/util.js";
import lang_ from "@/js/locales";

export default {
  name: "restaurant",
  data () {
    return {
      isLoading: false,
      finished: false,
      upLoading: true,
      imgH: 0,
      page: 0,
      pageSize: 15,
      window_c: {
        Loading: "加載中"
      },
      params: {
        brandId: "",
        pageIndex: 0,
        pageSize: 15
      },
      datas: [],
      // 是否顯示收藏
      showCollect: false
    };
  },
  created () {
    console.log("123456787654321", util.getBrandId(this, 10));
    util.getBrand(this, () => {
      this.params.brandId = util.getBrandId(this);
      this.upLoading = false;
    });
    let arr = ['localhost:8080', 'hktest.ricepon.com:64377', 'm.gingersoft.com.hk'];
    if (arr.indexOf(location.host) > -1) {
      this.showCollect = true;
    }
  },
  mounted () {
    let J = util.getWindowInner();
    let w = J.w;
    let innerWidth = w - 40;
    this.imgH = innerWidth / 2;
  },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      window_c["Loading"] = lang_.t("Loading");
    },
    onRefresh () {
      this.isLoading = true;
      this.finished = false;
      this.upLoading = false;
      this.params.pageIndex = 1;
      this.getRestaurantNewList("down");
    },
    onUpLoad () {
      this.upLoading = true;
      this.params.pageIndex++;
      this.getRestaurantNewList("up");
    },
    // 獲取輪播列表
    getRestaurantNewList (t) {
      var self = this;
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: self.window_c["Loading"]
      });
      getRestaurantNew(this.params).then(res => {
        console.log(res);
        self.$toast.clear();
        if (res.code == "1") {
          if (t == "down") {
            this.datas = res.data;
            this.isLoading = false;
          } else {
            if (res.data.length == 0) {
              this.finished = true;
            }
            this.upLoading = false;
            this.datas = this.datas.concat(res.data);
          }
          this.checkSort();
        }
      });
    },
    toDetails (index, id) {
      sessionStorage.brandIndex = index;
      this.$router.push({
        name: "restaurant_details",
        params: {
          arg: util.setQueryParams([util.getBrandId(this), id])
        }
      });
    },
    /**
     * 點擊收藏
     */
    onColler (item) {
      let defaultColl = localStorage.getItem(`default_coll_list_${util.getBrandId(this, 1)}`);
      if (defaultColl) {
        let arr = JSON.parse(defaultColl);
        let f = false;
        for (let i = 0; i < arr.length; i += 1) {
          if (item.id == arr[i]) {
            arr.splice(i, 1);
            f = true;
            break;
          }
        }
        if (!f) {
          arr.push(item.id);
        }
        localStorage.setItem(`default_coll_list_${util.getBrandId(this, 1)}`, JSON.stringify(arr));
      } else {
        let arr = [];
        arr.push(item.id);
        localStorage.setItem(`default_coll_list_${util.getBrandId(this, 1)}`, JSON.stringify(arr));
      }
      this.checkSort();
    },
    checkSort () {
      let defaultColl = localStorage.getItem(`default_coll_list_${util.getBrandId(this, 1)}`);
      if (defaultColl) {
        let arr = JSON.parse(defaultColl);
        let data = this.datas;
        for (let i = 0; i < data.length; i += 1) {
          data[i].collSort = 0;
          for (let j = 0; j < arr.length; j += 1) {
            if (arr[j] == data[i].id) {
              data[i].collSort = j + 1;
              break;
            }
          }
        }
        data.sort((a, b) => {
          return b.collSort - a.collSort;
        })
        this.datas = data;
      }
    }
  },
  components: {
    headNav,
    PullRefresh,
    List
  }
};
</script>
<style scoped lang="less">
.self-restaurant-content {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 !important;
}

.self-restaurant-body {
  min-height: 100%;
  padding-top: 46px;
  background-color: #fff;
}

.self-restaurant-refresh {
  min-height: 100%;
  padding-bottom: 50px;
  background-color: #fff;
}

.self-restaurant-list-item {
  margin: 20px;
  width: calc(100% - 40px);
  border-radius: 8px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
  background-color: #fff;
}

.self-restaurant-list-img {
  width: 100%;
  vertical-align: middle;
}

.self-restaurant-item-line {
  padding: 10px;
  display: flex;
  align-items: baseline;
  .self-restaurant-item-name {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #3c3c3c;
  }
  .self-restaurant-item-address {
    display: flex;
    padding-top: 5px;
    align-items: center;
    img {
      width: 18px;
      background-color: #000;
    }
    span {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #3c3c3c;
    }
  }
  .default-box {
    flex-grow: 1;
  }
  .coll {
    margin-left: auto;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    .active {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/brand/restaurant_list.vue